import { get, post, put, deleted } from '..';
import routes from './routes';

const StateServices = {
  createState: async (obj) => {
    const data = await post(routes.createState, obj);
    return data;
  },
  getStates: async (params) => {
    const data = await get(routes.getStates, params);
    return data;
  },
  getStateById: async (id) => {
    const data = await get(routes.getStateById + id);
    return data;
  },
  updateState: async (id, obj) => {
    const data = await put(routes.updateState + id, obj);
    return data;
  },
  deleteState: async (id) => {
    const data = await deleted(routes.deleteState + id);
    return data;
  },
  getInfoByZipCode: async (zipCode) => {
    const data = await get(routes.getInfoByZipCode + zipCode);
    return data;
  },
}

export default StateServices